// 此文件是通过脚本生成的，直接编辑无效！！！

// 不需要导航框架的页面路径
export const noFrames = [
    '/alipay/result',
    '/',
    '/login_back',
    '/login',
    '/update',
    '/validate',
    '/wxlogin'
];

// 不需要登录就可以访问的页面路径
export const noAuths = [
    '/alipay/result',
    '/',
    '/login_back',
    '/login',
    '/update',
    '/validate',
    '/wxlogin'
];

// 需要keep alive 页面
export const keepAlives = [
    {
        path: '/iframe_page_/:src',
        keepAlive: true,
    }
];

// 页面路由配置
export default [
    {
        path: '/assort/:acid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/actor/assort.jsx'),
    },
    {
        path: '/actor',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/actor/index.jsx'),
    },
    {
        path: '/alipay/result',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/alipay/index.jsx'),
    },
    {
        path: '/census/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/census/index.jsx'),
    },
    {
        path: '/checkData/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/checkData/index.jsx'),
    },
    {
        path: '/checkfact/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/checkFact/index.jsx'),
    },
    {
        path: '/company/:ft',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/company/index.jsx'),
    },
    {
        path: '/contract',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/contract/index.jsx'),
    },
    {
        path: '/contrast/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/contrast/index.jsx'),
    },
    {
        path: '/control/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/control/index.jsx'),
    },
    {
        path: '/correct/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/correct/index.jsx'),
    },
    {
        path: '/culture/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/culture/index.jsx'),
    },
    {
        path: '/daily',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/daily/index.jsx'),
    },
    {
        path: '/dept/:cid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/dept/index.jsx'),
    },
    {
        path: '/doc/:gid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/doc/index.jsx'),
    },
    {
        path: '/document/:ft',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/document/index.jsx'),
    },
    {
        path: '/example/table-editable',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/examples/table-editable/index.jsx'),
    },
    {
        path: '/exception',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/exception/index.jsx'),
    },
    {
        path: '/factor/:fid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/factor/index.jsx'),
    },
    {
        path: '/factors/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/factors/index.jsx'),
    },
    {
        path: '/failure/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/failure/index.jsx'),
    },
    {
        path: '/files/:did',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/files/index.jsx'),
    },
    {
        path: '/forward/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/forward/index.jsx'),
    },
    {
        path: '/gen',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/gen/index.jsx'),
    },
    {
        path: '/home',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/home/index.jsx'),
    },
    {
        path: '/hourData/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/hourData/index.jsx'),
    },
    {
        path: '/hourDataChart/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/hourDataChart/index.jsx'),
    },
    {
        path: '/iframe_page_/:src',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/iframe/index.jsx'),
    },
    {
        path: '/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/index/index.jsx'),
    },
    {
        path: '/journey',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/journey/index.jsx'),
    },
    {
        path: '/license/:uid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/license/index.jsx'),
    },
    {
        path: '/login_back',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/login/index_back.jsx'),
    },
    {
        path: '/login',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/login/index.jsx'),
    },
    {
        path: '/loginlog',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/loginlog/index.jsx'),
    },
    {
        path: '/manual/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/manual/index.jsx'),
    },
    {
        path: '/map',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/map/index.jsx'),
    },
    {
        path: '/material/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/material/index.jsx'),
    },
    {
        path: '/menus',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/menus/index.jsx'),
    },
    {
        path: '/message/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/message/index.jsx'),
    },
    {
        path: '/minData/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/minData/index.jsx'),
    },
    {
        path: '/minDataChart/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/minDataChart/index.jsx'),
    },
    {
        path: '/module',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/module/index.jsx'),
    },
    {
        path: '/notice/:uid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/notice/index.jsx'),
    },
    {
        path: '/online/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/online/index.jsx'),
    },
    {
        path: '/operate/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/operate/index.jsx'),
    },
    {
        path: '/operation',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/operation/index.jsx'),
    },
    {
        path: '/order',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/order/index.jsx'),
    },
    {
        path: '/packet/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/packet/index.jsx'),
    },
    {
        path: '/patrol/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/patrol/index.jsx'),
    },
    {
        path: '/permit/:cid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/permit/index.jsx'),
    },
    {
        path: '/pollute',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/pollute/index.jsx'),
    },
    {
        path: '/prefact',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/prefact/index.jsx'),
    },
    {
        path: '/preset/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/preset/index.jsx'),
    },
    {
        path: '/proofs/:mid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/proofs/index.jsx'),
    },
    {
        path: '/ranks/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/ranks/index.jsx'),
    },
    {
        path: '/realData/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/realData/index.jsx'),
    },
    {
        path: '/realDataChart/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/realDataChart/index.jsx'),
    },
    {
        path: '/record/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/record/index.jsx'),
    },
    {
        path: '/region/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/region/index.jsx'),
    },
    {
        path: '/renewal/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/renewal/index.jsx'),
    },
    {
        path: '/repair/:rid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/repair/index.jsx'),
    },
    {
        path: '/reportDay/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/reportDay/index.jsx'),
    },
    {
        path: '/reportMonth/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/reportMonth/index.jsx'),
    },
    {
        path: '/reportWeek/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/reportWeek/index.jsx'),
    },
    {
        path: '/reportYear/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/reportYear/index.jsx'),
    },
    {
        path: '/river/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/river/index.jsx'),
    },
    {
        path: '/roles',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/roles/index.jsx'),
    },
    {
        path: '/situa/:uid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/situa/index.jsx'),
    },
    {
        path: '/station/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/station/index.jsx'),
    },
    {
        path: '/stations/:ft',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/stations/index.jsx'),
    },
    {
        path: '/stationList/:ft',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/stations/indexList.jsx'),
    },
    {
        path: '/summary/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/summary/index.jsx'),
    },
    {
        path: '/update',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/update/index.jsx'),
    },
    {
        path: '/user/:uid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/user/index.jsx'),
    },
    {
        path: '/users',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/users/index.jsx'),
    },
    {
        path: '/validate',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/validate/index.jsx'),
    },
    {
        path: '/vehicle/:ft',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/vehicle/index.jsx'),
    },
    {
        path: '/video-flv/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/video/index_flv.jsx'),
    },
    {
        path: '/video-back/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/video/index.back.jsx'),
    },
    {
        path: '/video/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/video/index.jsx'),
    },
    {
        path: '/videos',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/videos/index.jsx'),
    },
    {
        path: '/view/',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/view/index.jsx'),
    },
    {
        path: '/viewHead',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/viewHead/index.jsx'),
    },
    {
        path: '/waste/:sid',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/waste/index.jsx'),
    },
    {
        path: '/watershed',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/watershed/index.jsx'),
    },
    {
        path: '/well',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/well/index.jsx'),
    },
    {
        path: '/work',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/work/index.jsx'),
    },
    {
        path: '/wxlogin',
        component: () => import('D:/Workspace/StormWork/environ-web/src/pages/wxlogin/index.jsx'),
    }
];
    